import {
    GETENTITYMAPPINGLIST_SUCCESS,
    GETENTITYMAPPINGLIST_FAILED,
    RESET_GETENTITYMAPPINGLIST,
    LOADING_GETENTITYMAPPINGLIST,
    NETWORK_ERROR_GETENTITYMAPPINGLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetEntityMappingList = () => {
    return { type: RESET_GETENTITYMAPPINGLIST };
};

const getEntityMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETENTITYMAPPINGLIST });
    await adminServices
        .post("getEntityMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getEntityMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(getEntityMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETENTITYMAPPINGLIST, payload: err });
        });
};
function getEntityMappingListsuccess(data) {
    return {
        type: GETENTITYMAPPINGLIST_SUCCESS,
        payload: data,
    };
}
function getEntityMappingListFailed(data) {
    return {
        type: GETENTITYMAPPINGLIST_FAILED,
        payload: data,
    };
}

export { resetGetEntityMappingList, getEntityMappingList };
